import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=3d0f17f4&scoped=true&"
import script from "./UpdateProfile.vue?vue&type=script&lang=ts&"
export * from "./UpdateProfile.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateProfile.vue?vue&type=style&index=0&id=3d0f17f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f17f4",
  null
  
)

export default component.exports